import { useEffect, useEffectEvent, useMemo, useState } from 'react'

import type { Moment } from '@app/utils/moment'
import moment from '@app/utils/moment'

// Maximum timeout for settimeout is 2^31 (max signed 32 bit integer).
// Value higher than that is treated as 0, i.e fires immediately
const MAX_TIMEOUT = Math.pow(2, 31) - 1

/**
 *
 * @param date string that moment understands or Moment instance
 */
export const useTimer = (date: string | Moment, getNow = () => moment()) => {
  const mdate = useMemo(() => moment(date), [date])
  const [now, setNow] = useState(getNow())
  const expired = useMemo(() => now.isSameOrAfter(mdate), [mdate, now])

  const scheduleTick = useEffectEvent(() => {
    if (expired) return

    const time = Math.min(mdate.valueOf() - now.valueOf(), MAX_TIMEOUT)

    const timeout = setTimeout(() => {
      setNow(getNow())
    }, time)

    return () => {
      clearTimeout(timeout)
    }
  })

  useEffect(() => scheduleTick(), [mdate, now])

  return expired
}
